module.exports = __webpack_public_path__ + "img/znxg2.2497a0f2.png";